module.exports = __webpack_public_path__ + "img/143.c3405a43.jpg";